<template>
    <li class="cart-detail-row">
        <div class="cart-detail-remove">
            <a class="i-remove" href="#" @click.prevent="m_remove_all"></a>
        </div>
        <div class="cart-detail-title">
            <span>{{ p_item.intQty }} {{ d_candy && d_candy.strTitle }}</span>
        </div>
        <div class="cart-detail-price">
            <span v-html="m_total(option)"></span>
        </div>
        <div class="cart-detail-btns">
            <a class="i-minus" href="#" @click.prevent="m_del_candy()"></a>
            <a class="i-plus" href="#" @click.prevent="m_add_candy()"></a>
        </div>
    </li>
</template>
<script>
import $ from 'jquery';

export default {
    name: "candycart",
    props: {
        p_item: { type: Object, default: () => null }
    },
    watch: {
        p_item: function () {
            //actualiza los datos al sacar un item del cart.          
            this.m_add_update_ticket_candy_and_option();
        }
    },
    data() {
        return {
            d_candy: null,
            d_option: {
                intValue: 0,
                lstBalances: []
            }
        }
    },
    mounted() {
        this.m_add_update_ticket_candy_and_option();
    },
    methods: {
        m_remove_all: function () {
            this.$root.m_del_all_ticket_candy(this.p_item.strMCode, this.p_item.strBarcode, this.p_item.intRecogId, this.p_item.intQty, this.p_item.boms, this.p_item.intPromoId);
        },
        m_tickets_candys_qty: function () {
            if (this.d_candy && this.p_item)
                return this.p_item.intQty * this.d_ticket.intTicketsQty;
            else
                return 0;
        },
        m_total: function () {
            var option = this.d_option;
            var priceOptions = 0;
            if (this.p_item.boms != null) {
                this.p_item.boms.forEach(b => {
                    b.Options.forEach(opt => {
                        priceOptions = priceOptions + ((opt.intQty * opt.intPrice) * this.p_item.intQty);
                    })
                });
            }
            var price = `$ ${((option.intValue * this.p_item.intQty + priceOptions) / 100).toLocaleString('es-AR')}`;
            var balances = "";
            if (option.lstBalances.length > 0) {
                option.lstBalances.forEach(balance => {
                    if (balance.intPoints > 0) {
                        if (balances.length > 0) {
                            balances += " + ";
                        }
                        balances += `${(balance.intPoints * this.p_item.intQty).toLocaleString('es-AR')} ${this.m_get_balance_name(balance.enuPointsType, balance.intBalanceId, true)}`;
                    }
                });
            }
            if (option.lstBalances.length > 0 && option.lstBalances.some(balance => balance.intPoints > 0)) {
                return price + ' + ' + balances;
            }
            else {
                return price;
            }
        },
        m_add_candy: function () {
            this.$root.m_add_candy(this.p_item.strMCode, this.p_item.strBarcode, this.p_item.intRecogId, this.p_item.intPromoId, this.p_item.boms);
        },
        m_del_candy: function () {
            this.$root.m_del_candy(this.p_item.strMCode, this.p_item.strBarcode, this.p_item.intRecogId, this.p_item.intPromoId, this.p_item.boms);
        },
        m_add_update_ticket_candy_and_option: function () {
            if (this.p_item) {
                this.d_candy = this.$root.m_get_ticket_candy(this.p_item.strMCode, this.p_item.strBarcode);
                this.d_option = this.$root.m_get_option_candy(this.d_candy, this.p_item.intRecogId, this.p_item.intPromoId);
            }
        },
        m_view_boms_details: function () {
            $(this.$refs.bomdetails).slideToggle();
            $(this.$refs.bomdetails2).slideToggle();
        },
        m_close_boms_details: function () {
            this.d_bpopup.close();
        },
        m_get_title_option: function (id) {
            var name = "";
            try {
                this.d_candy.BOMs && this.d_candy.BOMs.forEach(bom => {
                    bom.Options && bom.Options.forEach(option => {
                        if (option.strOptionItemId == id) {
                            name = option.strTitle;
                            throw "";
                        }
                    })
                })
            } catch (error) { /*Ignored*/ }
            return name;
        },
        m_get_bom_strmcode: function (id) {
            var strMCode = "";
            try {
                this.d_candy.BOMs && this.d_candy.BOMs.forEach(bom => {
                    bom.Options && bom.Options.forEach(option => {
                        if (option.strOptionItemId == id) {
                            strMCode = option.strMCode;
                            throw "";
                        }
                    })
                })
            } catch (error) { /*Ignored*/ }
            return strMCode;
        },
        m_get_balance_name: function (enuPointsType, intBalanceId, forCart) {
            return this.$root.m_get_balance_name(enuPointsType, intBalanceId, forCart);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/CandyCart.vue